/*
 * decaffeinate suggestions:
 * DS002: Fix invalid constructor
 * DS101: Remove unnecessary use of Array.from
 * DS102: Remove unnecessary code created because of implicit returns
 * DS207: Consider shorter variations of null checks
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
import React from 'react';
import { createFragmentContainer, graphql } from 'react-relay';

import { Input } from './ui/input';
import { Button } from './ui/button';
import { cn } from '../lib/utils';
import Linkify from 'react-linkify';

import Replies from './Replies';

import ReplyMutation from '../mutations/ReplyMutation';
import formatDate from '../formatDate';

class Message extends React.Component {
  constructor(props) {
    super(props);
    this.onSend = this.onSend.bind(this);
    this.state = {
      showAction: null,
      text: '',
    };
  }

  onAction(action) {
    return e => {
      if (action.kind === 'text') {
        return this.setState({
          showAction: action,
        });
      } else {
        return ReplyMutation.commit(null, action.id);
      }
    };
  }

  onSend(e) {
    e.preventDefault();
    this.setState({
      loading: true,
    });
    return ReplyMutation.commit(
      null,
      this.state.showAction.id,
      this.state.text,
      () => {
        return this.setState({
          loading: false,
          showAction: null,
          text: '',
        });
      },
    );
  }

  render() {
    const { classes, message } = this.props;

    return (
      <div className="mb-3 p-3 bg-white rounded-lg border border-gray-200 shadow-sm hover:shadow-md transition-shadow duration-200">
        <div className="mb-2">
          <h3 className="text-base font-semibold text-gray-900 mb-1">{message.title}</h3>
          <div className="flex flex-wrap items-center gap-x-3 gap-y-0.5 text-xs text-gray-500">
            <span>{formatDate(message.createdAt)}</span>
            {this.props.showChannel && message.channel != null && (
              <span>via {message.channel.name}</span>
            )}
            {message.receiver != null && (
              <span>sent to {message.receiver.fullName}</span>
            )}
          </div>
        </div>
        {message.body ? (
          <div className="mb-2 text-sm text-gray-700 leading-relaxed">
            <Linkify
              properties={{
                target: '_blank',
                style: { color: 'hsl(var(--primary))', fontWeight: '600', textDecoration: 'underline' },
              }}
            >
              {message.body.split('\n').map((item, key) => {
                return (
                  <React.Fragment key={key}>
                    {item}
                    <br />
                  </React.Fragment>
                );
              })}
            </Linkify>
          </div>
        ) : null}
        <Replies message={message} />
        {this.state.showAction ? (
          <form className="flex flex-row gap-2 mt-3" name="send" onSubmit={this.onSend}>
            <Input
              onChange={e => this.setState({ text: e.target.value })}
              value={this.state.text}
              autoFocus
              className="flex-1 max-w-md h-9"
              placeholder="Type your reply..."
            />
            <Button type="submit" disabled={this.state.loading} size="sm">
              {this.state.loading ? 'Sending...' : 'Send'}
            </Button>
          </form>
        ) : (
          <div className="flex flex-wrap gap-2 mt-3">
            {message.actions && Array.from(message.actions).map(action => (
              <Button
                onClick={this.onAction(action)}
                key={`${action.id}`}
                variant={action.kind === 'text' ? 'outline' : 'default'}
                size="sm"
                className="transition-all duration-200 hover:scale-105"
              >
                {action.value}
              </Button>
            ))}
          </div>
        )}
      </div>
    );
  }
}

Message = createFragmentContainer(Message, {
  message: graphql`
    fragment Message_message on Message {
      id
      title
      body
      createdAt
      ...Replies_message
      channel {
        id
        name
      }
      receiver {
        id
        fullName
      }
      actions {
        id
        value
        kind
      }
    }
  `,
});

export default Message;
